export const PreferenceOptions = {
    Account: 'account',
    Profile: 'profile',
    Notifications: 'notifications'
};

export const nameInitials = (first, last) => {
    return first.charAt(0).toUpperCase() + last.charAt(0).toUpperCase()
}

export const AccountBasicInfoFields = [
    "participant_name_first",
    "participant_name_last",
    "account_birthdate",
    "participant_email_account"
];

export const CurrentPasswordField =
{
    idField: "participant_current_password",
    field_type: "password",
    field_description: "",
    field_conditional: "",
    field_label: "Current password",
    field_default_value: "",
    field_name: "participant_current_password",
    field_visibility: true,
    read_only: false,
    field_options: [],
    field_validation: {
        required: [
            false,
            ""
        ],
        min: null,
        max: null,
        maxlength: null,
        file_extension: null,
        file_size: null,
        file_multi_files: null,
        file_firestore_storage: null,
        file_cloud_storage: null,
        file_is_shared: null,
        file_is_renameable: null
    },
    linked_fields: ["participant_account_password"],
    multi_fields: []
}
export const NewPasswordField =
{
    idField: "participant_account_password",
    field_type: "password",
    field_description: "",
    field_conditional: "",
    field_label: "New password",
    field_default_value: "",
    field_name: "participant_account_password",
    field_visibility: true,
    read_only: false,
    field_options: [],
    field_validation: {
        required: [
            false,
            ""
        ],
        min: [6, "Password must be at least 6 characters long."],
        max: null,
        maxlength: null,
        file_extension: null,
        file_size: null,
        file_multi_files: null,
        file_firestore_storage: null,
        file_cloud_storage: null,
        file_is_shared: null,
        file_is_renameable: null
    },
    linked_fields: ["participant_current_password"],
    multi_fields: []
}